import React from 'react';

function Footer() {
    return (
        <footer className="py-12 border-t border-gray-800">
            <div className="flex flex-col gap-8">
                {/* Links Section */}
                <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-8 text-gray-400">
                    <a 
                        href="//twitter.com/fuserobotics" 
                        className="hover:text-fuse-orange transition-colors"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Twitter
                    </a>
                    <a 
                        href="//dash.fuserobotics.io" 
                        className="hover:text-fuse-orange transition-colors"
                    >
                        Dashboard
                    </a>
                    <span className="hidden md:inline text-gray-700">|</span>
                    <a 
                        href="legal/privacy.html" 
                        className="hover:text-fuse-orange transition-colors"
                    >
                        Privacy Policy
                    </a>
                    <a 
                        href="legal/terms.html" 
                        className="hover:text-fuse-orange transition-colors"
                    >
                        Terms of Service
                    </a>
                    <a 
                        href="legal/refund.html" 
                        className="hover:text-fuse-orange transition-colors"
                    >
                        Refund Policy
                    </a>
                </div>

                {/* Copyright Section */}
                <div className="text-center text-gray-600 text-sm">
                    <p>© Fuse Robotics LTD - Registered business in England and Wales 13211130</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;

